import { Box, TextField, Grid, Typography, Divider } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useEffect } from "react";
import { useState } from "react";

export const inputs = [
  { name: "name", type: "text", label: "Emri i fushes" },
  // { name: "price", type: "number", label: "Çmimi", min: 0 },
  { name: "length", type: "number", label: "Dimensionet (gjatësia)", min: 0 },
  { name: "width", type: "number", label: "Dimensionet (gjerësia)", min: 0 },
];

export const checkboxes = [
  { label: "Futboll", name: "isFootball" },
  { label: "Basketboll", name: "isBasketball" },
  { label: "Tenis", name: "isTennis" },
  { label: "Volejboll", name: "isVolleyball" },
  {label: "Padel", name:"isPadel"}
];

export default function FieldForm({ setFields, fields }) {
  const [fieldsNumber, setFieldsNumber] = useState(new Array(1).fill(1));

  const selectedFields = {
    Tenis: fields?.Tenis,
    Volejboll: fields?.Volejboll,
    Basketboll: fields?.Basketboll,
    Futboll: fields?.Futboll,
    Padel: fields?.Padel
  }

  const availableCheckboxes = checkboxes.filter(checkbox => selectedFields[checkbox.label]);

  useEffect(()=>{
  console.log("selectedFields",selectedFields);
  console.log("availableCheckboxes", availableCheckboxes);

  }, [selectedFields, availableCheckboxes])
  return (
    <>
      {/* <Box m={2}>
        <Grid container>
          <Grid item xs={12} md={4}>
            <TextField
              type="number"
              label="Nr. i fushave per tu krijuar"
              fullWidth
              value={+fieldsNumber.length}
              // onChange={(e) => setFieldsNumber(() => new Array(+e.target.value).fill(1))}
            />
          </Grid>
        </Grid>
      </Box> */}

      {fieldsNumber.map((_element, _index) => (
        <React.Fragment key={_index}>
          <Grid
            container
 
            alignItems="flex-start"
            justifyContent="space-between"
            m={2}
          >
        
            <Grid item xs={12} md={4}>
              {/* <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Fusha numer {_index + 1}
              </Typography> */}
              <Grid container spacing={2}>
                {inputs.map((input) => (
                  <Grid item xs={12} key={input.label}>
                    <TextField
                      name={input.name}
                      label={input.label}
                      type={input.type}
                      inputProps={{ min: input.min ?? 0 }}
                      fullWidth
                      onChange={(e) => {
                        const newFields = structuredClone(fields);
                        newFields.locations[_index] = {
                          ...newFields.locations[_index],
                          [e.target.name]: e.target.value,
                        };
                        setFields((f) => ({
                          ...f,
                          locations: newFields.locations,
                        }));
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={8} >
              <Grid container justifyContent="center" p={4}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Zgjidhni llojin e fushës
                  </Typography>
                  <RadioGroup
                    value={fields?.locations?.[_index]?.fieldType || ""}
                    onChange={(e) => {
                      const newFields = structuredClone(fields);
                      newFields.locations[_index] = {
                        ...newFields.locations[_index],
                        fieldType: e.target.value,
                      };
                      setFields((f) => ({
                        ...f,
                        locations: newFields.locations,
                      }));
                    }}
                  >
                    {availableCheckboxes.map((checkbox) => (
                      <FormControlLabel
                        key={checkbox.name}
                        value={checkbox.name}
                        control={<Radio />}
                        label={checkbox.label}
                      />
                    ))}
                  </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Zgjidhni kohëzgjatjen e seances
                  </Typography>
                  <RadioGroup
                    row
                    value={fields?.locations?.[_index]?.slotRange}
                    onChange={(e) => {
                      const newFields = structuredClone(fields);
                      newFields.locations[_index] = {
                        ...newFields.locations[_index],
                        slotRange: +e.target.value,
                      };
                      setFields((f) => ({
                        ...f,
                        locations: newFields.locations,
                      }));
                    }}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <FormControlLabel
                      value={60}
                      control={<Radio />}
                      label="1 orë"
                    />
                    <FormControlLabel
                      value={90}
                      control={<Radio />}
                      label="1 orë e gjysëm"
                    />
                    <FormControlLabel
                      value={120}
                      control={<Radio />}
                      label="2 orë"
                    />
                  </RadioGroup>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
          <Divider sx={{ my: 2 }} />
        </React.Fragment>
      ))}
    </>
  );
}
